import * as a from "react";
import { P as i } from "./index-wif4gfZf.js";
import { j as t } from "./utils-BdNIfrGQ.js";
var o = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), s = "VisuallyHidden", d = a.forwardRef(
  (r, e) => /* @__PURE__ */ t.jsx(
    i.span,
    {
      ...r,
      ref: e,
      style: { ...o, ...r.style }
    }
  )
);
d.displayName = s;
export {
  d as V,
  o as a
};
